var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCustom = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_979_49214)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_979_49214)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_979_49214)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.0191,
    cy: 25.3487,
    rx: 12.3003,
    ry: 12.8175,
    stroke: "currentColor",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.019,
    cy: 25.3511,
    rx: 4.5317,
    ry: 4.72222,
    stroke: "currentColor",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.0194,
    cy: 25.3498,
    rx: 8.53402,
    ry: 8.89281,
    stroke: "currentColor",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1537 24.517C25.6948 24.9952 25.7105 25.7548 26.1886 26.2137C26.6668 26.6726 27.4265 26.657 27.8853 26.1788L26.1537 24.517ZM39.9672 11.8558H38.7672V13.0558H39.9672V11.8558ZM41.9094 11.8558L42.7752 12.6867C43.1082 12.3398 43.2018 11.8276 43.0133 11.3852C42.8247 10.9429 42.3903 10.6558 41.9094 10.6558V11.8558ZM40.0263 13.8181L39.1605 12.9872L40.0263 13.8181ZM39.7951 10.0114L40.6609 10.8423L39.7951 10.0114ZM38.0808 11.7978L38.9466 12.6287L38.0808 11.7978ZM27.8853 26.1788L38.8909 14.7105L37.1593 13.0488L26.1537 24.517L27.8853 26.1788ZM39.2251 13.8797V11.9363H36.8251V13.8797H39.2251ZM38.9466 12.6287L40.6609 10.8423L38.9293 9.18054L37.215 10.9669L38.9466 12.6287ZM38.7672 10.0807V11.8558H41.1672V10.0807H38.7672ZM39.9672 13.0558H41.9094V10.6558H39.9672V13.0558ZM41.0436 11.025L39.1605 12.9872L40.8921 14.649L42.7752 12.6867L41.0436 11.025ZM39.882 12.6797H38.0251V15.0797H39.882V12.6797ZM39.1605 12.9872C39.349 12.7907 39.6096 12.6797 39.882 12.6797V15.0797C40.2633 15.0797 40.6281 14.9241 40.8921 14.649L39.1605 12.9872ZM40.6609 10.8423C39.9748 11.5573 38.7672 11.0716 38.7672 10.0807H41.1672C41.1672 8.90953 39.7402 8.33556 38.9293 9.18054L40.6609 10.8423ZM39.2251 11.9363C39.2251 12.1944 39.1253 12.4425 38.9466 12.6287L37.215 10.9669C36.9648 11.2276 36.8251 11.575 36.8251 11.9363H39.2251Z",
    fill: "currentColor"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_979_49214",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_979_49214"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_979_49214",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_979_49214",
    x: -12,
    y: -9,
    width: 80.6279,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_979_49214"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_979_49214",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_979_49214"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCustom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/custom.e99455fb35b9fc9350f473dde32130e6.svg";